var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcbPaymentCard(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 35,
    viewBox: "0 0 52 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0h44a4 4 0 014 4v27a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.054 6C11.815 6 10 7.79 10 10v9.878c1.137.544 2.312.898 3.507.898 1.402 0 2.172-.845 2.172-1.98v-4.642h3.487v4.642c0 1.814-1.13 3.27-5.005 3.27-2.332 0-4.161-.496-4.161-.496V30h5.946C18.185 30 20 28.209 20 26V6h-5.946zm22 0C33.814 6 32 7.79 32 10v4.154h5.736c.117 0 .257.007.358.013l.04.002c1.298.064 2.255.722 2.255 1.864 0 .898-.654 1.665-1.845 1.837v.045c1.315.09 2.323.805 2.323 1.93 0 1.218-1.106 2-2.58 2H32V30h5.946C40.185 30 42 28.209 42 26V6h-5.946zM34 20.68h2.376c.075 0 .216-.012.283-.026.456-.096.836-.488.836-1.022 0-.535-.38-.928-.836-1.024a1.821 1.821 0 00-.283-.026H34v2.098zm2.25-5.343c.42.07.78.41.78.916a.912.912 0 01-.78.915c-.04.006-.146.017-.22.017H34V15.32h2.03c.074 0 .18.01.22.017zM21 10c0-2.21 1.815-4 4.054-4H31v20c0 2.209-1.815 4-4.054 4H21v-9.236c1.027.87 2.804 1.413 5.69 1.285 1.544-.07 3.183-.479 3.183-.479v-1.692c-.807.4-1.803.79-3.07.883-2.19.164-3.509-.892-3.509-2.76 0-1.87 1.318-2.926 3.508-2.763 1.268.095 2.25.475 3.07.884V14.43s-1.638-.409-3.182-.477c-2.886-.128-4.663.415-5.69 1.285V10z",
    fill: "#fff"
  })));
}

export default SvgJcbPaymentCard;